<div class="w-100 mx-auto pt-3 pb-5 px-2 px-md-2" style="max-width: 1500px;">
  <div class="container-fluid w-100">
    <div class="row mt-2 mb-1">
      <div class="col-12 col-md-8">
        <div class="d-flex align-items-center justify-content-start h-100">
          <h3 class="fs-md-30 fw-normal">{{ dealerName }} Dealer Portal</h3>
        </div>
      </div>
      <div class="col-12 col-md-4">
      </div>
    </div>

    <div class="row mt-3">
      <!-- LEFT COLUMN -->
      <div class="col-12 col-lg-8 order-2 order-lg-1">
        <div class="border border-1 shadow-sm rounded-lg p-3">
          <div class="mb-2">
            <p class="fs-md-22 mb-0">{{ dateRangeTitle }} Overview</p>
            <span *ngIf="dateRange !== ''" class="text-muted">Showing Metrics From {{ dateRange }}</span>
          </div>

          <!-- BODY -->
          <div>

            <!-- CHART -->
            <div class="bg-light rounded-3 px-1 pt-1 pb-3 px-md-3 pt-md-3">
              <div>
                  <pla-metric-graph-collection
                    *ngIf="!metricLoading && dealerMetrics && dealerMetrics.length > 0"
                    [metrics]="dealerMetricsConfig"
                    [description]="''">
                  </pla-metric-graph-collection>

                <h4 class="mt-4 mb-2">DVLA</h4>
                <pla-metric-graph-collection
                  *ngIf="!metricLoading && dealerMetrics && dealerMetrics.length > 0"
                  [metrics]="dvlaDealerMetricsConfig"
                  [description]="''">
                </pla-metric-graph-collection>

                  <div *ngIf="metricLoading" class="mb-3 w-100 bg-white skeleton" style="min-height: 250px">
                    <div class="skeleton-item w-100 h-100" style="min-height: 250px;"></div>
                  </div>

                  <div *ngIf="!metricLoading && (!dealerMetrics || dealerMetrics.length == 0)" class="mb-3 d-flex align-items-center justify-content-center" style="min-height: 250px;">
                    <p class="my-0 fs-md-25 w-100 text-center mx-auto">No Results...</p>
                  </div>
              </div>

              <div class="d-block d-md-flex align-items-center justify-content-between end gap-3">
                <div class="mb-2 mb-md-0" style="min-width: 200px">
                  <pla-custom-dropdown [containerClass]="'w-100 border border-1 rounded-3 bg-white'"
                       [showShadow]="false"
                       [config]="metricRangeDropdownConfig"
                       (change)="metricRangeSortChange($event)"></pla-custom-dropdown>
                </div>

                <div  class="d-flex align-items-center justify-content-center justify-content-md-end gap-3">
                  <div class="d-flex align-items-center justify-content-start gap-2">
                    <div style="width: 20px; height: 20px; background: #1b9b8a" class="d-block rounded-3"></div>
                    <p class="my-0">Views</p>
                  </div>

                  <div class="d-flex align-items-center justify-content-start gap-2">
                    <div style="width: 20px; height: 20px; background: #214953" class="d-block rounded-3"></div>
                    <p class="my-0">Plate Clicks</p>
                  </div>

                  <div class="d-flex align-items-center justify-content-start gap-2">
                    <div style="width: 20px; height: 20px; background: #fab82b" class="d-block rounded-3"></div>
                    <p class="my-0">Dealer Clicks</p>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="dealerStockInfo && dealer != '*all*'" class="mt-4 d-block d-md-flex align-items-stretch justify-content-between gap-4">
              <div class="bg-light rounded-3 w-100 p-3 mt-0 d-flex align-items-stretch justify-content-between flex-column">
                <div class="d-flex align-items-center justify-content-start gap-2 mb-1">
                  <mat-icon>inventory_2</mat-icon>
                  <p class="my-0 fs-md-19 lh-sm">Stock Count</p>
                </div>
                <p class="fs-md-40 lh-sm my-0"><span class="fs-md-40 fw-bold sm" [appCountUp]="dealerStockInfo.stockCount" [duration]="1000"></span> <span class="ms-2 lh-sm fs-md-16">registrations</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="col-12 col-lg-4 order-1 order-lg-2">
        <div class="mb-3" *ngIf="isAdmin && dealerDropdownConfig && dealerDropdownConfig.options.length > 0">
          <pla-custom-dropdown [containerClass]="'w-100 border border-1 rounded-3 bg-white'"
                               [optionClass]="'border-start border-end border-bottom border-1'"
                               [openedClass]="'border-bottom'"
                               [showShadow]="false"
                               [config]="dealerDropdownConfig"
                               (change)="dealerChange($event)"></pla-custom-dropdown>
        </div>

        <div *ngIf="dealer != '*all*'" class="border border-1 shadow-sm rounded-lg p-3">
          <!-- BODY -->
          <div>
            <div class="d-block">
              <button (click)="ClickManageDVLA()" class="border-0 bg-light rounded-3 w-100 p-3 mt-0 mt-md-0 hover-interact pointer d-flex align-items-stretch justify-content-between flex-column">
                <div class="d-flex align-items-center justify-content-start gap-2 mb-1">
                  <mat-icon class="x-large">lock</mat-icon>
                  <div>
                    <p class="fs-md-19 lh-sm my-0 d-block w-100 text-start">DVLA Stock</p>
                    <p class="fs-md-20 lh-sm my-0 fw-bold w-100 text-start">Click to manage</p>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="dealer != '*all*'" class="mt-3 mb-3 border border-1 shadow-sm rounded-lg p-3">
          <div class="d-flex align-items-center">
            <p class="fs-md-22">Your Dealer Plan</p>
          </div>
          <div>
            <ul>
              <li>£5 per click per plate (refreshes monthly)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- BILLABLE PLATE CLICKS -->
    <div class="row">
      <!-- LEFT COLUMN -->
      <div *ngIf="payableRegistrations && payableRegistrations.length > 0" class="col-12 col-lg-12">
        <div class="mt-4 border border-1 shadow-sm rounded-lg p-3">
          <div class="d-block d-md-flex align-items-center justify-content-between gap-2">
            <p class="fs-md-22 my-0">Billable List</p>
          </div>
          <div class="border-top border-1 my-2"></div>
          <div>
            <div class="position-relative">
              <table class="table table-striped" style="height: fit-content">
                <thead>
                <tr>
                  <th scope="col">Registration</th>
                  <th scope="col" *ngIf="dealer === '*all*'">Dealer</th>
                  <th scope="col">Date</th>
                </tr>
                </thead>
                <tbody>
                <tr class="h-100 hover-interact pointer" *ngFor="let registration of payableRegistrations">
                  <th scope="row">
                    <div class="d-flex align-items-center justify-content-start">
                      <pla-plate [openModal]="false" [rawPlate]="registration.formattedRegistration"
                                 [customClass]="'flat shaded'" [plateSize]="'ns-s'" [smallPlate]="false"
                                 [mobileTiny]="true"></pla-plate>
                    </div>
                  </th>
                  <td *ngIf="dealer === '*all*'">
                    <div class="h-100">
                      <div class="h-100 d-flex align-items-center justify-content-start">
                        <span>{{ registration.dealer }}</span>
                      </div>
                    </div>
                  </td>

                  <td class="h-100">
                    <div class="h-100 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
                      <span class="lh-sm d-none d-md-block">{{ registration.date | date: 'longDate' }}</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- LEFT COLUMN -->
      <div *ngIf="dealer != '*all*'" class="col-12 col-lg-12">
        <div class="mt-4 border border-1 shadow-sm rounded-lg p-3">
          <div class="d-block d-md-flex align-items-center justify-content-between gap-2">
            <p class="fs-md-22 my-0">Stock List</p>

            <div class="d-flex align-items-stretch justify-content-end gap-2">
              <!-- SEARCHABLE -->
              <div class="w-100 mx-auto search-input" style="max-width: 350px">
                <div class="mx-auto h-100 rounded-2 overflow-hidden position-relative bg-white border">
                  <div class="mx-auto h-100 d-flex align-items-stretch justify-content-between py-2">
                    <div class="bg-transparent h-100 w-100">
                      <pla-new-search-input [disabled]="stockSearching" [emitOnInput]="true" [placeholder]="'Search'"
                                            [searchTexts]="[]" [internalRouting]="false" [searchTrigger]="searchTrigger"
                                            [weight]="'normal'" [fixedHeight]="false"
                                            (searchEvent)="filterSearchResults($event)"></pla-new-search-input>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SORTABLE-->
              <div class="w-100" style="min-width: 190px; max-width: 190px">
                <pla-custom-dropdown [containerClass]="'border border-1 rounded-3'"
                                     [showShadow]="false"
                                     [config]="stockSortDropdownConfig"
                                     (change)="stockSortChange($event)"></pla-custom-dropdown>
              </div>
            </div>
          </div>
          <div class="border-top border-1 my-2"></div>
          <div>
            <div *ngIf="registrationResponse && registrationResponse.registrations && registrationResponse.registrations.length === 0">
              <p class="my-0 fs-md-25 w-100 text-center my-5 mx-auto">No Results...</p>
            </div>

            <div class="position-relative"  *ngIf="registrationResponse && registrationResponse.registrations && registrationResponse.registrations.length > 0">
              <table class="table table-striped" style="height: fit-content">
                <thead>
                <tr>
                  <th scope="col">Registration</th>
                  <th scope="col">Listing Price</th>
                  <th scope="col">Status</th>
                  <th scope="col">Sole Seller</th>
                </tr>
                </thead>
                <tbody>
                  <tr class="h-100 hover-interact pointer" (click)="ClickManageDealerPlate(plateDetailModal, registration)" *ngFor="let registration of registrationResponse.registrations">
                    <th scope="row">
                      <div class="d-flex align-items-center justify-content-start">
                      <pla-plate [openModal]="false" [rawPlate]="registration.formatted_registration"
                                 [customClass]="'flat shaded'" [plateSize]="'ns-s'" [smallPlate]="false"
                                 [mobileTiny]="true"></pla-plate>
                      </div>
                    </th>
                    <td>
                      <div class="h-100">
                        <div class="h-100 d-flex align-items-center justify-content-start">
                          <span>{{ registration.price_minor / 100 | currency: 'GBP' }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="h-100">
                      <div class="h-100 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
                        <div class="rounded-circle d-block" style="width: 10px; height: 10px; background: #1b9b8a"></div>
                        <span class="lh-sm d-none d-md-block">Available</span>
                      </div>
                    </td>

                    <td class="h-100">
                      <div class="h-100 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
                        <div class="rounded-circle d-block" style="width: 10px; height: 10px;"
                           [ngStyle]="{
                              'background-color': registration.sole_supplier ? '#1b9b8a' : '#9b211b'
                          }"
                        ></div>
                        <span class="lh-sm d-none d-md-block">{{ registration.sole_supplier ? 'Sole Supplier' : 'Multiple Sellers' }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="position-absolute top-0 end-0 bottom-0 end-0 w-100 h-100 d-flex align-items-center justify-content-center" *ngIf="stockSearching" style="background: rgba(0,0,0,0.3)">
                <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
              </div>
            </div>

            <div *ngIf="registrationResponse && registrationResponse.registrations && registrationResponse.pagination && registrationResponse.registrations.length > 0" class="d-flex align-items-center justify-content-end">
              <mat-paginator [length]="registrationResponse.pagination.total" [pageIndex]="registrationResponse.pagination.page - 1" [pageSize]="10" [hidePageSize]="true" (page)="paginate($event)"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="false">
  <div class="py-4 px-4 text-center">
      <pla-metric-portal></pla-metric-portal>
  </div>
  <div class="py-4 px-4 text-center">
<!--      <pla-registration-metrics *ngIf="registrationString" [search]="search"></pla-registration-metrics>-->
  </div>
</div>

<ng-template #plateDetailModal>
  <div class="py-2 px-3">
    <pla-plate [openModal]="false" [rawPlate]="selectedRegistration.formatted_registration"
               [customClass]="'flat shaded'" [plateSize]="'smaller'" [smallPlate]="false"
               [mobileTiny]="true"></pla-plate>

    <p class="mt-2">Make changes to this plates price and availability.</p>

    <div *ngIf="selectedRegistration !== null">
      <pla-basic-input [prefixIcon]="'currency_pound'" [emitOnInput]="true" [value]="(selectedRegistration.price_minor / 100).toFixed(2)" (valueChange)="SelectedRegPriceChange($event)"></pla-basic-input>
    </div>

<!--    <pre class="bg-light">{{ selectedRegistration | json }}</pre>-->

    <div class="mt-3 d-flex align-items-center justify-content-between gap-3">
      <button (click)="detailModal.close()" class="btn btn-success w-100">Save</button>
      <button (click)="detailModal.close()" class="btn btn-outline-danger w-100">Close</button>
    </div>
  </div>
</ng-template>
